import { render, staticRenderFns } from "./AddBlockModal.vue?vue&type=template&id=d59ba544"
import script from "./AddBlockModal.vue?vue&type=script&lang=js"
export * from "./AddBlockModal.vue?vue&type=script&lang=js"
import style0 from "./AddBlockModal.vue?vue&type=style&index=0&id=d59ba544&prod&lang=styl"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports